
import {defineComponent} from "vue";
import {PropType} from "vue/dist/vue";
import InputText from "@/components/UI/InputText.vue";
import {MasterProductCategoryRestDto} from "@/api/pharma-cpc-product/models";
import {ProductCategoryCustomerNameOverviewRestDto} from "@/api/pharma-cpc-product-category-mgmt/models";
import {
  MultilingualFieldRestDtoModel
} from "@/models/api/pharma-cpc-product-category-mgmt/MultilingualFieldRestDtoModel";

export default defineComponent({
  name: "RenameDPSubCategory",
  components: {InputText},
  emits: ['nameChanged', 'toggleOpen'],
  props: {
    categoriesTreeItem: {
      type: Object as PropType<MasterProductCategoryRestDto>,
      required: true,
    },
    categoryNames: {
      type: Object as PropType<Record<string, ProductCategoryCustomerNameOverviewRestDto>>,
      required: true,
    },
    open: {
      type: Object as PropType<Set<string>>,
      required: true,
    },
    level: {
      type: Number,
      required: true
    },
    language: {
      type: String,
      required: true
    },
    allLanguages: {
      type: Array as PropType<string[]>,
      required: true
    },
    errors: {
      type: Object,
      required: true
    },
  },
  computed: {
    hasChildren(): boolean {
      return this.categoriesTreeItem.subcategories?.length > 0;
    },
    categoryName(): ProductCategoryCustomerNameOverviewRestDto {
      return this.categoryNames[this.categoriesTreeItem.code] ?? {
        code: this.categoriesTreeItem.code,
        custom_name: MultilingualFieldRestDtoModel.createWithDefaults()
      };
    },
    isOpen(): boolean {
      return this.open.has(this.categoriesTreeItem.code);
    },
    paddingStyle(): string {
      return 'padding-left: ' + (this.level * 15) + 'px';
    }
  },
  methods: {
    toggleOpen(code: string) {
      this.$emit('toggleOpen', code);
    },
    onNameChanged() {
      this.$emit('nameChanged');
    }
  }
});
